import { create } from "zustand";
import { InterfaceChaseItem } from "../types/chase-item-types";
import { DriverInterface } from "../types/driver-type";

export interface DriverResponseInterface extends DriverInterface {
  chaseItem: InterfaceChaseItem[];
}

interface IdefaultValues {
  id: number | string;
  data: Record<string, any>;
  isEdited?: boolean | null;
}

const defaultValues = {
  id: "",
  data: {},
  isEdited: null,
};

interface IuseChaseEdit {
  onOpen: ({ id, data }: IdefaultValues) => void;
  onClose: () => void;
  initialValues: IdefaultValues;
}

export const useChaseEditModel = create<IuseChaseEdit>((set) => ({
  initialValues: defaultValues,
  onOpen: ({ id, data }: IdefaultValues) =>
    set({
      initialValues: { id, data, isEdited: null },
    }),
  onClose: () =>
    set({
      initialValues: { ...defaultValues, isEdited: null },
    }),
}));
